'use strict';

const $ = jQuery.noConflict();
import {gsap} from 'gsap';
import {TextPlugin} from 'gsap/TextPlugin';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {SplitText} from 'gsap/SplitText';

gsap.registerPlugin(TextPlugin, ScrollTrigger, SplitText);

const Animations = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.animationsOneWordTitleVideo();
		this.animationsBannertitle();
		this.lineAnimation();
		this.videoTestimonials();
		this.teamVideos();
		this.sliderAnimation();
		this.typingText();
		this.addClassesOnTimeOut();
	},

	addClassesOnTimeOut: function() {
		document.querySelector('.video-cursor').classList.add('cursor-fixed');
		document.querySelector('.video-fallower').classList.add('cursor-fixed');
	},

	typingText: function() {

		gsap.utils.toArray('.gsap-text-block').forEach(function(elem) {
			const splitTimeline = gsap.timeline({scrollTrigger: {
				trigger: elem,
			}
			});

			const split = new SplitText(elem);

			splitTimeline.from (
				split.words, {
					duration: .5,
					opacity: 0,
					y: 150,
					transformOrigin: 'bottom top',
					stagger: .05,
					delay: .2,
				}
			);
		});
	},


	//need to add the function on slider swipe to
	sliderAnimation: function() {
		const arrows = document.querySelectorAll('.gsap-testimonials-arrows');

		for (let i = 0; i < arrows.length; i++) {
			const arrow = arrows[i];
			const quote = gsap.utils.toArray('.gsap-testimonials-box__wrap-title');

			for (let j = 0; j < quote.length; j++) {
				const element = quote[j];
				const mySplitText = new SplitText(element, {type: 'words'});
				const splitTextTimeline = gsap.timeline();
				gsap.set(element, {perspective: 400});

				arrow.addEventListener('click', function() {
					mySplitText.split({type: 'lines'});
					splitTextTimeline.from(mySplitText.lines, {
						duration: 1,
						opacity: 0,
						y: 200,
						transformOrigin: 'bottom top',
						stagger: .4,
						delay: 1,
					});
				});
			}
		}
	},

	videoTestimonials: function() {

		gsap.set('.video-fallower', {
			xPercent: -50,
			yPercent: -50,
			opacity: 0,
		});
		gsap.set('.video-cursor', {
			xPercent: -50,
			yPercent: -50,
			opacity: 0
		});

		const videoTabsContainer = document.querySelector('.js-video-tabs__boxes');

		const vids = document.querySelectorAll('.js-video-tabs__box-video');
		const vidFirst = vids[0];
		const vidSecond = vids[1];

		const vidsTxt = document.querySelectorAll('.js-video-tabs__boxes-overlay-txt');
		const elementFirst = vidsTxt[0];
		const elementSecond = vidsTxt[1];

		const vidBox = document.querySelectorAll('.js-video-tabs__box');
		const boxFirst = vidBox[0];
		const boxSecond = vidBox[1];

		const boxWrapp = document.querySelectorAll('.js-video-tabs__box-wrap');
		const wrappFirst = boxWrapp[0];
		const wrappSecond = boxWrapp[1];

		elementFirst.addEventListener('click', function() {
			wrappFirst.click();
		}),

		elementSecond.addEventListener('click', function() {
			wrappSecond.click();
		}),

		videoTabsContainer.addEventListener('mouseleave', () => {
			document.querySelector('.js-video-tabs__box.video-active .js-video-tabs__box-video').play();
		});

		window.addEventListener('scroll', function() {
			const position = vidFirst.getBoundingClientRect();

			if(position.top < 200) {
				// vidFirst.play();
				document.querySelector('.js-video-tabs__box.video-active .js-video-tabs__box-video').play();
			}
		});

		boxFirst.classList.add('video-active');
		elementFirst.classList.add('txt-active');

		let follow = document.querySelector('.video-fallower');
		let cur = document.querySelector('.video-cursor');

		document.querySelector('.video-tabs__boxes-overlay').addEventListener('mousemove', e => {
			gsap.to(cur, 0.2, {
				x: e.clientX,
				y: e.clientY,
				opacity: 1,
			});

			gsap.to(follow, 0.9, {
				x: e.clientX,
				y: e.clientY,
				opacity: 1,
			});
		});

		document.querySelector('.video-tabs__boxes-overlay').addEventListener('mouseout', e => {
			gsap.to(cur, 0.2, {
				x: e.clientX,
				y: e.clientY,
				opacity: 0,
			});

			gsap.to(follow, 0.9, {
				x: e.clientX,
				y: e.clientY,
				opacity: 0,
			});
		});

		elementFirst.addEventListener('mouseenter', function() {
			vidFirst.play();
			vidSecond.pause();
			if(boxSecond.classList.contains('video-active')) {
				boxSecond.classList.remove('video-active');
			}

			if(elementSecond.classList.contains('txt-active')) {
				elementSecond.classList.remove('txt-active');
			}

			boxFirst.classList.add('video-active');
			elementFirst.classList.add('txt-active');
			// Check if screen width is more then 1024px
			if(window.innerWidth > 1024) {
				$(this).find('.js-play-button').css('display', 'none');
			}
		});

		elementFirst.addEventListener('mouseleave', function() {
			vidFirst.pause();
			if(window.innerWidth > 1024) {
				$(this).find('.js-play-button').css('display', 'block');
			}
		});

		elementSecond.addEventListener('mouseenter', function() {
			vidFirst.pause();
			vidSecond.play();
			if(boxFirst.classList.contains('video-active')) {
				boxFirst.classList.remove('video-active');
			}

			if(elementFirst.classList.contains('txt-active')) {
				elementFirst.classList.remove('txt-active');
			}

			boxSecond.classList.add('video-active');
			elementSecond.classList.add('txt-active');
			if(window.innerWidth > 1024) {
				$(this).find('.js-play-button').css('display', 'none');
			}
		});

		elementSecond.addEventListener('mouseleave', function() {
			vidSecond.pause();
			if(window.innerWidth > 1024) {
				$(this).find('.js-play-button').css('display', 'block');
			}
		});

	},

	lineAnimation: function() {
		const lines = gsap.utils.toArray('.gsap-video-block__line');

		lines.forEach(line => {

			gsap.set(line, {y: -200});

			gsap.to(line, {
				scrollTrigger: {
					trigger: line,
				},
				y: 0,
				opacity: 1,
				duration: 2,
				transformOrigin: 'top center',
				ease: 'power1.inOut',
			});
		});
	},

	teamVideos: function() {
		const vids = document.getElementsByClassName('js-team-block__box-video');
		// Check if scren widht is more then 1204px
		if(window.innerWidth > 1204) {
			for (let i = 0; i < vids.length; i++) {
				const element = vids[i];
				element.addEventListener('mouseenter', function() {
					element.play();
				});
				element.addEventListener('mouseleave', function() {
					element.pause();
				});
			}
			return;
		}

		for (let i = 0; i < vids.length; i++) {
			const element = vids[i];

			element.play();
		}
	},

	animationsOneWordTitleVideo: function() {
		const titles = gsap.utils.toArray('.gsap-video-tabs__title');

		titles.forEach(title => {

			gsap.set(title, {y: -150, opacity: 0});

			gsap.to(title, {
				scrollTrigger: {
					trigger: title,
				},
				y: 0,
				opacity: 1,
				duration: 2,
				transformOrigin: 'top center',
				ease: 'power1.inOut',
			});
		});
	},

	animationsBannertitle: function() {
		const quote = document.querySelectorAll('.gsap-banner-title');

		// Check if any elements with class 'gsap-banner-title' are found
		if (quote.length > 0) {
			const mySplitText = new SplitText(quote, {type: 'words'});
			const splitTextTimeline = gsap.timeline();

			gsap.set(quote, {perspective: 400});

			mySplitText.split({type: 'lines'});
			splitTextTimeline.from(mySplitText.lines, {
				duration: 1.5,
				opacity: 0,
				y: 230,
				transformOrigin: 'bottom top',
				stagger: 0.4,
			});
		}
	},
};

export default Animations;
